import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

const billState = (state: RootState) => state.bill;

const selectLatestBills = createSelector(
  billState,
  (state) => state.latestBills || []
);

const selectLatestBillsLoading = createSelector(
  billState,
  (state) => state.latestBillsLoading
);

const selectLatestBillsMeta = createSelector(
  billState,
  (state) => state.latestBillsMeta
);

const selectBillsTablePageSize = createSelector(
  billState,
  (state) => state.billsTablePageSize || 10
);

const selectBillsTablePage = createSelector(
  billState,
  (state) => state.billsTablePage || 1
);

const selectCurrentBillNumber = createSelector(
  billState,
  (state) => state.currentBillNumber
);

export const billSliceSelectors = {
  selectLatestBills,
  selectLatestBillsLoading,
  selectLatestBillsMeta,
  selectBillsTablePageSize,
  selectBillsTablePage,
  selectCurrentBillNumber,
};
